import { cn } from 'utils';
import Text from '../Text';

interface Props {
  title: string;
  description: string;
  className?: string;
}

const DescriptionBarFull = ({ title, description, className }: Props) => {
  return (
    <div className={cn('w-full border-b border-border-dimmed px-4 py-6 md:px-0', className)}>
      <h2 className="mb-2 text-heading3 font-medium">{title}</h2>
      <Text weight="regular" color="description">
        {description}
      </Text>
    </div>
  );
};

export default DescriptionBarFull;
